import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FcpProgressBarModule } from '../fcp-progress-bar';
import { FcpButtonModule } from '../fcp-button';

@Component({
    selector: 'fcp-load-more',
    imports: [FcpProgressBarModule, FcpButtonModule],
    templateUrl: './fcp-load-more.component.html',
    styleUrls: ['./fcp-load-more.component.less']
})
export class FcpLoadMoreComponent {
    @Input() progress: number;
    @Input() disabled: boolean;
    @Input() loadMoreLabel: string;
    @Input() loadMoreButtonLabel: string;

    @Output() loadMore = new EventEmitter();
}
